import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  IUser,
  IUserOption,
} from '@kinet-open-network/shared/data-access/model';

export class UserOption
  extends BaseModel<UserOption, 'UserOption'>
  implements IUserOption
{
  static override readonly modelName: AbilitySubjectType = 'UserOption';

  category!: string;
  subcategory!: string | null;
  name!: string | null;
  description!: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data!: Record<string, any>;
  order?: number;
  userId!: string;
  user!: IUser;
}
